import { QRApps } from "./qr-apps";

export { QRApps };
